export default class GenericUploadError extends Error {}
